import { DetailSegmentSelectListener } from "@l2r-front/l2r-common"

import { useRoadwayStateContext } from "../../contexts/RoadwayContext"

export function RoadwayDetailSegmentSelectListener() {

    const { selectedNetworkYearlyStatus } = useRoadwayStateContext()

    return <DetailSegmentSelectListener layerId={selectedNetworkYearlyStatus?.layer} />
}